import { Controller } from "stimulus";

export default class extends Controller {
  confirmStudySelect(event) {
    const row = event.currentTarget;
    const studyCode = row.dataset.studyCode;
    const studyTitle = row.dataset.studyTitle;
    const hubUrl = row.dataset.hubUrl;

    Swal.fire({
      title: `Are you sure you want to view <b>${studyCode}</b> study?`,
      html: `<span class="text-sm text-gray-600">${studyTitle}</span>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = hubUrl;
      }
    });
  }

  confirmSiteVisit(event) {
    const row = event.currentTarget;
    const siteCode = row.dataset.siteCode;
    const siteName = row.dataset.siteName;
    const subjectsUrl = row.dataset.subjectsUrl;

    Swal.fire({
      title: `Are you sure you want to view <b>${siteCode}</b> site?`,
      html: `<span class="text-sm text-gray-600">${siteName}</span>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = subjectsUrl;
      }
    });
  }
}
